import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { storage } from '../firebase/firebase-config';

export function sanitizeStorageFileName(fileName) {
  const trimmed = (fileName || 'file').trim();
  const safe = trimmed.replace(/[/\\?%*:|"<>#]/g, '_');
  return safe.slice(0, 120) || 'file';
}

function createUniqueId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

/** Unique Storage path: `{folder}/{tenantId?}/{uuid}_{originalName}` */
export function buildUniqueStoragePath(folder, file, { tenantId, prefix } = {}) {
  const safeName = sanitizeStorageFileName(file?.name);
  const uniqueId = createUniqueId();
  const segments = [folder.replace(/\/+$/, '')];

  if (tenantId) {
    segments.push(tenantId);
  }
  if (prefix) {
    segments.push(prefix.replace(/\/+$/, ''));
  }

  segments.push(`${uniqueId}_${safeName}`);
  return segments.join('/');
}

export function uploadFileToStorage(file, folder, { onProgress, tenantId, prefix } = {}) {
  return new Promise((resolve, reject) => {
    const storagePath = buildUniqueStoragePath(folder, file, { tenantId, prefix });
    const storageRef = ref(storage, storagePath);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      'state_changed',
      (snapshot) => {
        if (onProgress) {
          onProgress((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        }
      },
      reject,
      async () => {
        const url = await getDownloadURL(uploadTask.snapshot.ref);
        resolve(url);
      },
    );
  });
}
